/**
 * menus/type_2.js
 * theme_type = 'type_2' (kumon/교원) 전용 GNB 구성.
 *
 * 현재는 type_1과 동일한 구성이지만, kumon 전용 메뉴가 필요하면
 * 이 파일에서 SITEMAPS / MENUS 를 독립적으로 수정하세요.
 * base.js의 SECTIONS·GROUPS·ITEMS·TABS는 자유롭게 import해서 사용 가능합니다.
 *
 * 예시 (책자/포스터만 노출):
 *   export const MENUS = [
 *       { GROUP: GROUPS.DIGITAL_BOOKLETS, SECTIONS: [...] },
 *       { GROUP: GROUPS.DIGITAL_POSTERS,  SECTIONS: [...] },
 *   ];
 */

export { SITEMAPS, MENUS } from './type_1.js';
